export default __webpack_public_path__ + "static/media/01_seminko-min.f5354961.jpg";